import { isPlainObject } from "lodash-es";

/**
 * Recursively omits specified keys from an object, including nested objects and arrays.
 */
export const deepOmit = <T>(obj: T, ...keysToOmit: string[]): T => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepOmit(item, ...keysToOmit)) as T;
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  const result = {} as Record<string, unknown>;
  for (const [key, value] of Object.entries(obj)) {
    if (!keysToOmit.includes(key)) {
      result[key] = deepOmit(value, ...keysToOmit);
    }
  }

  return result as T;
};
